// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shared-input-field {\n  width: 100%;\n}\n.shared-input-field > .MuiTextField-root {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://src/app/shared/components/SharedInputField/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb","sourcesContent":[".shared-input-field {\n  width: 100%;\n}\n.shared-input-field > .MuiTextField-root {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
